import { Button, Layout, Text } from '@loadsmart/miranda-react'
import { toSpacingCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { type TenderAttachment } from '../domain/TenderOffer'
import { useDownloadAttachment } from './hooks/useDownloadAttachment'

export function AttachmentList({
  tenderAttachments,
  quoteUuid,
}: {
  tenderAttachments: TenderAttachment[]
  quoteUuid?: string
}) {
  const { download, isLoading } = useDownloadAttachment()

  if (tenderAttachments?.length === 0) {
    return null
  }

  return (
    <Layout.Stack gap="spacing-2">
      <Text variant="body-md-bold" color="color-text-primary">
        Attachments
      </Text>
      <Layout.Stack gap="spacing-2">
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: toSpacingCSSValue('spacing-2'),
          }}
        >
          {tenderAttachments.map(attachment => (
            <li key={attachment.id}>
              <Layout.Box
                padding="spacing-2"
                borderRadius="border-radius-s"
                borderWidth="border-thin"
                borderColor="color-border"
              >
                <Layout.Group justify="space-between" align="center">
                  <Text variant="body-md">{attachment.fileName}</Text>
                  <Button
                    variant="tertiary"
                    onClick={() => {
                      if (quoteUuid) {
                        download(attachment.id, quoteUuid)
                      }
                    }}
                    disabled={isLoading || !quoteUuid}
                    loading={isLoading}
                  >
                    View
                  </Button>
                </Layout.Group>
              </Layout.Box>
            </li>
          ))}
        </ul>
      </Layout.Stack>
    </Layout.Stack>
  )
}
